export default __webpack_public_path__ + "static/media/apple_watch_4.53054929.png";